<template>
  <div class="footer-box">
    <footer class="footer container">
      <div class="footer-left">
        <ul class="clearfix">
          <li v-for="(item,index) in guideArr" :key="index">
            <router-link :to="item.value">{{item.name}}</router-link>
          </li>
        </ul>
        <div style="width:100%;margin-top:30px; ">
          友情链接：
          <a href="http://www.ahcj.org.cn/">安徽省机动车辆检测协会</a> &nbsp;&nbsp;&nbsp;&nbsp;
          <a href="http://cjyj.ahsuli.com/login/">机动车预警平台</a>
        </div>
        <div style="width:100%;margin-top:35px;">版权所有：COPYRIGHT &nbsp;©&nbsp;2020&nbsp;安徽省机动车辆检测协会</div>
        <div style="margin-top:35px;">
          <a target="_blank" href="http://beian.miit.gov.cn/">皖ICP备 18026647 号</a>
        </div>
      </div>
      <ul class="footer-right" style="color:#f00">
        <li>
          <div class="divs" style="text-align: center;">
            <a>联系我们</a>
          </div>
        </li>
        <li style="text-align:center">
          <img class="conImg" src="../../assets/image/wechatApp.jpg" alt />
          <div class="conTit">微信小程序</div>
        </li>
        <li>
          <div class="phone divs">
            <span class="el-icon-phone"></span>
            <a style="margin-left:5px" href="tel:0551-65652128">0551-65652128</a>
          </div>
        </li>
        <!-- <li>
          <div class="weixin">
            <img src="../../assets/image/weixin.png" alt srcset />
          </div>
        </li>-->
      </ul>
    </footer>
  </div>
</template>

<script>
export default {
  name: "Footer",
  data() {
    return {
      linkItemClass: "link-item",
      guideArr: [
        { name: "关于我们", value: "aboutUs" },
        { name: "新手指南", value: "newUser" },
        { name: "如何购买", value: "howBuy" },
      ],
    };
  },
};
</script>

<style scoped lang="less">
/*****************************底 部 开 始*****************************/
.footer-box {
  width: 100%;
  min-height: 150px;
  color: rgba(153, 161, 166, 1);
  font-size: 14px;
  background-color: rgba(28, 31, 33, 1);
}
.footer {
  padding-top: 24px;
  height: 100%;
  overflow: hidden;
}
.footer-left {
  float: left;
  width: 52%;
  overflow: hidden;
}
.footer-left li {
  width: 25%;
  float: left;
  overflow: hidden;
}
.footer-left li .divs {
  width: 100%;
  margin-bottom: 12px;
}

.footer-left li a:hover {
  color: #fff;
  cursor: pointer;
}
.footer-right {
  float: right;
}
.footer-right li .divs {
  margin-bottom: 12px;
}
.weixin img {
  width: 34px;
  height: 34px;
}
.phone {
  color: rgba(153, 161, 166, 1);
  font-size: 22px;
  margin-top: 10px;
}
.footer-right li a:hover {
  color: #fff;
  cursor: pointer;
}
.conImg {
  width: 100px;
}
.conTit {
  font-size: 14px;
  color: #666666;
  margin: 0;
}
a {
  // color: #fff;
  text-decoration: none;
}
/*****************************底 部 结 束*****************************/
</style>
